// @ts-nocheck
import { Divider, Tooltip, Modal, Box } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react';
import NumberFormatter from '../../utils/NumberFormater';
import { FundsHeader } from '../../components/commonComponents/FundsHeader';
import { AuctionListHeader } from './AuctionListHeader';
import { ChatBroadcast } from './ChatBroadcaster';
import { useDispatch, useSelector } from 'react-redux';
import { getInvestorAuctionerUrl, getInvestorApiUrl } from '../../utils/config';
import { LiveIcon } from '../../components/Live';
import { useNavigate, useParams } from 'react-router-dom';
import { firstTimeClosingMenuBar } from '../../redux/slice/menuSlice';
import { useSignalR } from '../../services/context/SignalRContext';
import { AuctionStatus } from '../../components/liveauction/AuctionStatus';
import { getAuctionHistory } from '../../redux/slice/auctionIdSlice';
import { clearMyBidUpdates, MyBidApi } from '../../redux/slice/mybidSlice';
import { getRegisterdInvestors } from '../../redux/slice/userSlice';
import { setSelectedProfileForAuction } from '../../redux/slice/selectedProfileSlice';
import { Helmet } from 'react-helmet';
import { ApiRequestParams, handleFetchApi } from '../../utils/api';
import { Button } from '@mui/material';
import moment from 'moment';
import { FetchProfileList } from '../../redux/slice/PurchaseProfileList';
import { AppDispatch, RootState } from '@/redux/store';
export const LiveAuctionDetailed = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isFirstTime = useSelector((store: RootState) => store.menu.isFirstTime)
  const [bidAmount, setBidAmount] = useState(0);
  const [messages, setMessages] = useState([]);
  const [responseMessage, setResponseMessage] = useState('');
  const [broadcastMsg, setBroadcastMsg] = useState([])
  const [AuctioneerNeed, setAuctioneerNeed] = useState([])
  const [increment, setIncrement] = useState(1000); // Default increment
  const [chatData, setChatData] = useState(null)
  const [auctionList, setAuctionList] = useState([])
  const [auctionDetail, setAuctionDetail] = useState(null)
  const [funds, setFunds] = useState(null)
  const [message, setMessage] = useState(responseMessage?.message);
  const [status, setStatus] = useState(responseMessage?.status);
  const [isLive, setIsLive] = useState(null)
  const [showHighmsg, setshowHighmsg] = useState(false)
  const [loading, setLoading] = useState(false)
  const [notificationId, setNotificationId] = useState(null)
  const [outBidedId, setOutBidedId] = useState(null)
  const [isliveLoader, setisliveLoader] = useState(false)
  const [openProfileModal, setOpenProfileModal] = useState(false)
  const [selectedProfile, setSelectedProfile] = useState({ name: '', type: '' });
  // const [clickReponse, setClickResponse] = useState({})
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [errorId, setErrorId] = useState(null)
  const navigate = useNavigate()
  const { id: auctionId } = useParams()
  const { connection } = useSignalR();
  const excludedStatuses = ["Pause", "Cancelled", "Closed"];
  const isPostponed = isLive?.auctionStatus === "Postponed";
  const saleDateTime = auctionDetail?.srpSaleDateTime?.replace(/([+-]\d{2}:\d{2})$/, '');
  const isPastSaleDate = saleDateTime && new Date(saleDateTime) < new Date();
  
  
  const { userData, investorId } = useSelector((state: RootState) => state?.user);
  const dynamicProperties = useSelector((state: RootState) => state.mybid.myBidData.data?.Today || [])
  const localProperties = useSelector((state: RootState) => state?.mybid?.myBidUpdates || [])
  const excludeIds = useSelector((state: RootState) => state.mybid.removedAuctionsIds)
  const selectedProfiles = useSelector((state: RootState) => state.selectedProfile[auctionId]);
  const properties = dynamicProperties.length == 0 ? localProperties : dynamicProperties
  const profileList = useSelector((state: RootState) => state?.purchaseProfile?.profiles?.body);
    function formatToDollar(amount: any) {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0, // No decimal places
      maximumFractionDigits: 0,
    }).format(amount);
  }

  useEffect(() => {
    const fetchRegisteredInvestors = async () => {
      try {
        if (isFirstTime && userData?.email) {
          await dispatch(getRegisterdInvestors(userData.email)).unwrap();
        }
      } catch (error) {
        console.error('Failed to fetch registered investors:', error);
        // Optionally handle error (set error state, etc.)
      }
    };

    fetchRegisteredInvestors();
  }, [isFirstTime, userData?.email, dispatch]);

  const scrollContainerRef = useRef(null);
  const scroll = (direction: string) => {
    const scrollAmount = 300; // Adjust as needed
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: direction === 'right' ? scrollAmount : -scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (investorId) {
          await dispatch(MyBidApi(investorId)).unwrap();
          await dispatch(FetchProfileList(investorId)).unwrap();
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };

    fetchData();
  }, [investorId, dispatch]);

  const currentTime = moment().valueOf();

  const initialId = properties.filter((data) => {
    // First, check if the auction is live or pause
    const isLive = data.auctionStatus === 'Live'
    const isPause = data.auctionStatus === "Pause" && !excludeIds.includes(data.id);
    const isClosed = data.auctionStatus === "Closed" && !excludeIds.includes(data.id)
    // Then, check if the openingDate has passed
    const openingDate = moment.parseZone(data.srpSaleDateTime).valueOf(); // Convert the openingDate to a Date object
    const isTimePassed = openingDate <= currentTime && !excludeIds.includes(data.id);; // Check if openingDate is less than or equal to the current time
    // Return the item if both conditions are true
    return isLive || isTimePassed || isPause || isClosed;
  });
  useEffect(() => {
    if (auctionId) {
      return
    }
    if (initialId[0]?.id) {
      HandleAuction(initialId[0]?.id, "useEffect")
    }
  }, [properties])

  useEffect(() => {
    if (auctionId) {
      // Create an AbortController for canceling requests if needed
      const abortController = new AbortController();
      const signal = abortController.signal;

      // Store the controller to potentially abort later
      let currentRequest = null;

      const params: ApiRequestParams = {
        endpoint: `auction/${auctionId}`,
        baseUrl: getInvestorAuctionerUrl(),
        signal: signal,
      }
      // Cancel the previous request if a new one is triggered
      if (currentRequest) {
        currentRequest.abort();
      }
      // Start the new API request
      currentRequest = abortController;

      try {
        Promise.all([handleFetchApi(params).then((response) => {
          const auctionData = response.data?.data
          if ((auctionData?.auctionStatus === 'Upcoming' || auctionData?.auctionStatus === "PreAuctionClosed" || auctionData?.auctionStatus === "Postponed") && moment().valueOf() >= moment.parseZone(auctionData?.srpSaleDateTime).valueOf()) {
            const now = new Date();
            // Get ISO string and add fractional seconds manually
            const isoString = now.toISOString();

            setBroadcastMsg([{
              message: (<>Auction Starting Shortly... <br />Thank you for your patience. The auctioneer will join shortly to commence bidding. Please stay tuned!</>),
              selfMessage: null,
              userId: 0,
              createdTime: auctionData?.srpSaleDateTime?.replace(/([+-]\d{2}:\d{2})$/, ''),
              id: null,

            }]);
          }
          setAuctionDetail(auctionData)


          auctionData.currentHighestBid > 0 && setBidAmount(auctionData.currentHighestBid + increment)
        }), dispatch(getAuctionHistory({ id: auctionId, signal })).unwrap().then(({ data }) => {

          let messageContent;
          const messageArray = data.flatMap((item) => {
            messageContent = {
              broadCastMessage: item.investorBroadcastMessage,
              selfMessage: item.investorSelfMessage,
            };

            const data = messageContent.broadCastMessage.split(';')?.map(msg => msg.trim());
            if (item.userId === investorId) {
              return [{
                message: messageContent?.broadCastMessage?.includes(";") ? data[0] : "",
                selfMessage: null,
                userId: item?.userId,
                createdTime: item?.messageDateTime,
                id: item?.userId || null,
              },
              {
                message: "",
                selfMessage: messageContent?.selfMessage,
                userId: item?.userId,
                createdTime: item?.messageDateTime,
                id: item?.userId || null,
              }]
            } else {
              return data?.map((message) => {
                return {
                  message: message,
                  selfMessage: "",
                  userId: item?.userId,
                  createdTime: item.messageDateTime,
                  id: item?.userId || null,
                }
              })

            }

          })

          const array = messageArray.filter((message, index, self) =>
            index === self.findIndex(
              m => m.message === message.message && m.userId === message.userId && m.createdTime === message.createdTime && m?.selfMessage === message?.selfMessage
            )
          );

          setBroadcastMsg((prevMessages) => {
            return [...prevMessages, ...messageArray]
          }
          )
        }),
        ])

      } catch (error) {
        console.error(error)
      }
    }
  }, [auctionId])

  const RemoveAuctionfromList = async (auctionId: string) => {
    dispatch(MyBidApi(parseInt(investorId)))
    dispatch(clearMyBidUpdates(auctionId))
    connection.invoke("LeaveGroup", `${auctionId}`, `${investorId}`).catch((error) => console.error(error));
    if (initialId.length > 1) {
      if (initialId[0].id === auctionId) {
        await HandleAuction(initialId[1]?.id)
      } else {

        await HandleAuction(initialId[0]?.id)
      }
    }
    else {
      setBidAmount([])
      setChatData(null)
      setBroadcastMsg([])
      setAuctioneerNeed([])
      setResponseMessage('')
      setAuctionDetail(null)
      setIncrement(1000)
      navigate("/search")
    }
  }

  const HandleAuction = async (auction, status) => {
    setBidAmount(0)
    setChatData(null)
    setIncrement(1000)
    !status && setBroadcastMsg([])
    setAuctioneerNeed([])
    setResponseMessage('')
    setAuctionDetail(null)
    setLoading(true)
    setisliveLoader(true)
    setIsLive(null)

    if (auction) {
      navigate(`/liveauction/${auction}`,
      )
    }
  }

  const JoinGroup = async () => {
    if (!connection || connection.state !== 'Connected') {
      console.log('Connection not ready, waiting for connection...');
      attemptReconnect()
      return;
    }

    try {
      await connection.invoke('JoinGroup', `${auctionId || initialId[0]?.id}`, `${investorId}`);
      console.log('Successfully joined group');
    } catch (error) {
      console.error('Error joining group:', error);
    }
  };

  useEffect(() => {
    const JoinAuctionGrup = async () => {
      if (connection) {
        await JoinGroup()
      }
    }
    JoinAuctionGrup()

  }, [isOnline, connection, auctionId])

  // useEffect(() =>{
  //   alert('reconnect initiated')
  // }, [isOnline])


  useEffect(() => {
    if (connection && auctionId && investorId) {
      JoinGroup(connection);
      connection.on(`ReceiveWalletBalance${parseInt(investorId)}`, (data) => {
        console.log(data, 'funds from beacon')
        setFunds(data)
      });


      connection.on(`ReceiveAllResponse${auctionId}`, (msg, time, data) => {
        console.log(data, 'data for proxy message')
        setMessage(data.message);
        setStatus(data?.statusCode);
        setErrorId(data?.data?.userId)
        setNotificationId(data?.data?.highestBidderId)
        setOutBidedId(data?.data?.lastOutBiddedId)
      })

      connection.on(`ReceiveLastBidMessage${auctionId}`, (response, date) => {
        console.log(response, date, "last")
        const messageDetailsArray = {
          message: response?.data?.message,
          selfMessage: null,
          userId: 1,
          createdTime: response?.data?.messageTime,
          id: 0,
        }
        setBroadcastMsg(prevMessages => {
          return [...prevMessages, messageDetailsArray]
          // .filter((newMessage, index, self) => {
          //   return (
          //     self.findIndex((m) => m?.message === newMessage?.message && m?.createdTime === newMessage?.createdTime && m?.selfMessage === newMessage?.selfMessage && m?.userId === newMessage?.userId) ===
          //     index
          //   );
          // });
        });
      })

      connection.on(`ReceiveGroupMessage${auctionId}`, (msg, time, data) => {
        try {
          if (data?.statusCode === 200) {
            setChatData(data?.data);
            console.log(data?.data, 'Group Message')
            let messageContent;
            const isHighestProxyBidder = data?.data?.isHighestProxyBidder;
            const isHighestSellerBidder = data?.data?.isHighestSellerBidder;

            // Prepare message content
            messageContent = {
              broadCastMessage: data?.data?.broadCastMessage,
              selfMessage: data?.data?.selfMessage,
            };
            // Initialize message details array
            const messageDetailsArray = [];

            if (isHighestProxyBidder || isHighestSellerBidder) {
              // Split the broadcast message and only create two messages
              if (messageContent.broadCastMessage) {
                const [firstPart, secondPart] = messageContent.broadCastMessage.split(';')?.map(msg => msg.trim());
                // Add first part

                if (isHighestProxyBidder && data?.data?.highestBidderId == investorId || data?.data?.userId == 0) {
                  if (data?.data?.actionType == "RetractAsk" || data?.data?.actionType == 'RetractLocal') {
                    messageDetailsArray.push({
                      message: messageContent.broadCastMessage,
                      selfMessage: messageContent.selfMessage,
                      userId: data?.data?.userId || data?.userId,
                      createdTime: data?.data?.messageTime,
                      id: data?.data?.userId || null,
                      actionType: data?.data?.actionType
                    });
                  } else {
                    messageDetailsArray.push({
                      message: messageContent.broadCastMessage.includes(';') ? firstPart : "",
                      selfMessage: null,
                      userId: data?.data?.userId || data?.userId,
                      createdTime: data?.data?.messageTime,
                      id: data?.data?.userId || null,
                      actionType: data?.data?.actionType
                    });

                    messageDetailsArray.push({
                      message: null,
                      selfMessage: messageContent.selfMessage,
                      userId: data?.data?.userId || data?.userId,
                      createdTime: data?.data?.messageTime,
                      id: data?.data?.userId || null,
                      actionType: data?.data?.actionType
                    })
                  };

                } else {
                  messageDetailsArray.push({
                    message: firstPart,
                    selfMessage: null,
                    userId: data?.data?.userId || data?.userId,
                    createdTime: data?.data?.messageTime,
                    id: data?.data?.userId || null,
                    actionType: data?.data?.actionType
                  });
                  // Add second part
                  messageDetailsArray.push({
                    message: secondPart,
                    selfMessage: null,
                    userId: data?.data?.userId || data?.userId,
                    createdTime: data?.data?.messageTime,
                    id: data?.data?.userId || null,
                    actionType: data?.data?.actionType
                  });
                }
              }
            } else {
              if (data?.data?.userId == 0 && data?.data?.broadCastMessage.includes(';')) {
                messageDetailsArray.push({
                  message: messageContent.broadCastMessage.includes(';') ? messageContent.broadCastMessage.split(';')[0] : "",
                  selfMessage: messageContent.selfMessage,
                  userId: data?.data?.userId || data?.userId,
                  createdTime: data?.data?.messageTime,
                  id: data?.data?.userId || null,
                  actionType: data?.data?.actionType
                })
                messageDetailsArray.push({
                  message: messageContent.broadCastMessage.includes(';') ? messageContent.broadCastMessage.split(';')[1] : "",
                  selfMessage: messageContent.selfMessage,
                  userId: data?.data?.userId || data?.userId,
                  createdTime: data?.data?.messageTime,
                  id: data?.data?.userId || null,
                })
              } else {
                messageDetailsArray.push({
                  message: messageContent.broadCastMessage,
                  selfMessage: messageContent.selfMessage,
                  userId: data?.data?.userId || data?.userId,
                  createdTime: data?.data?.messageTime,
                  id: data?.data?.userId || null,
                  actionType: data?.data?.actionType
                });
              }
            }
            // Store updated messages in state
            setBroadcastMsg(prevMessages => {
              const updatedMessages = [...prevMessages, ...messageDetailsArray];
              // Filter out duplicate messages based on unique combination of message text, userId, and createdTime
              // const uniqueMessages = updatedMessages.filter((message, index, self) =>
              //   index === self.findIndex(
              //     m => m.message === message.message && m.userId === message.userId && m.createdTime === message.createdTime && m.selfMessage === message.selfMessage
              //   )
              // );
              // console.log(uniqueMessages, "group unique")

              return updatedMessages;
            });
          }
        } catch (error) {
          console.error(error, "error while creating broadcast message")
        }

      });
      connection.on(`UserJoined${auctionId}`, (user, groupname) => {
        console.log(user, groupname, 'Group Join Succesfully')
      });

      connection.on(`ReceiveBid${auctionId}`, (status, message) => {
        setResponseMessage({ message: message, status: status });
        console.log(status, message, 'recieved message')
      });
      // Cleanup function to remove event listeners when dependencies change
      return () => {
        if (connection) {
          connection.off(`ReceiveWalletBalance${parseInt(investorId)}`);
          connection.off(`ReceiveAllResponse${auctionId}`);
          connection.off(`ReceiveGroupMessage${auctionId}`);
          connection.off('UserJoined');
          connection.off(`ReceiveBid${auctionId}`);
          connection.off(`ReceiveLastBidMessage${auctionId}`)
          connection.off(`UserJoined${auctionId}`);
          connection.off(`UserLeft${auctionId}`);
        }
      };
    }
  }, [auctionDetail, auctionId, investorId, connection, isOnline, window.location.pathname]);

  const getFunds = async (id) => {
    try {
      await connection.invoke('GetWalletBalance', investorId);
    } catch (error) {
      console.error('Error placing bid:', error);
    }
  };

  useEffect(() => {
    if (connection) {
      const fetchData = () => {
        getFunds(parseInt(userData.userName));
      };
      fetchData();
    }
  }, [auctionDetail, connection, responseMessage, broadcastMsg]);

  const attemptReconnect = async (retryCount = 0, maxRetries = 5) => {
    if (!connection) {
      console.log('No connection instance available');
      return;
    }
    try {
      if (connection.state === 'Disconnected') {
        console.log(`Attempting to reconnect... (Attempt ${retryCount + 1}/${maxRetries})`);

        // Stop the existing connection first
        await connection.stop();

        // Start a new connection
        await connection.start();
        console.log(connection.state, 'Connection reestablished');
        // Only attempt to join group if connection is successful
        if (connection.state === 'Connected') {
          await JoinGroup();
        }
      }
    } catch (err) {
      console.error("Reconnection failed:", err);

      if (retryCount < maxRetries) {
        const delay = Math.min(1000 * Math.pow(2, retryCount), 30000);
        console.log(`Retrying in ${delay / 1000} seconds...`);
        setTimeout(() => attemptReconnect(retryCount + 1, maxRetries), delay);
      } else {
        console.error("Max retry attempts reached");
      }
    }
  };

  useEffect(() => {
    if (!connection) return;

    const handleConnectionClosed = async () => {
      console.log('Connection closed, initiating reconnect sequence');
      await attemptReconnect();
    };

    // Add event listeners
    connection.onclose = handleConnectionClosed;

    connection.onreconnecting = (error) => {
      console.log('Reconnecting...', error);
    };

    connection.onreconnected = (connectionId) => {
      console.log('Reconnected with connectionId:', connectionId);
      JoinGroup();
    };

    // Remove event listeners on cleanup
    return () => {
      // Properly remove event listeners
      if (connection) {
        connection.off('onclose');
        connection.off('onreconnecting');
        connection.off('onreconnected');
      }
    };
  }, [connection, auctionId, investorId]);

  useEffect(() => {
    if (isOnline && connection) {
      console.log('Internet connection restored');
      attemptReconnect();
    }
  }, [isOnline]);

  // Initial connection setup
  useEffect(() => {
    const setupInitialConnection = async () => {
      if (connection && auctionId && investorId) {
        try {
          if (connection.state === 'Disconnected') {
            await connection.start();
          }
          if (connection.state === 'Connected') {
            await JoinGroup();
          }
        } catch (error) {
          console.error('Error in initial connection setup:', error);
          attemptReconnect();
        }
      }
    };

    setupInitialConnection();

    return () => {
      if (connection) {
        // connection.stop();
      }
    };
  }, [connection, auctionId, investorId]);



  useEffect(() => {
    if (outBidedId == investorId) {
      setMessage(`You have been outbid!`)
      setStatus(201)
      setNotificationId(outBidedId)
    }
  }, [outBidedId])

  // useEffect(() => {
  //   const fetchingProperties = async () => {
  //     try {
  //       const propertyData = {
  //         pageNumber: 1,
  //         pageSize: 50,
  //         sortBy: "",
  //         sortDirection: "",
  //         isRemoteBidding: false,
  //         state: [],
  //         county: [],
  //         auctionStatus: [],
  //         propertyType: [],
  //         occupancyStatus: [],
  //         reportVacant: "",
  //         startPriceRange: 0,
  //         endPriceRange: 0,
  //         beds: 0,
  //         baths: 0,
  //         sqFtStartRange: 0,
  //         sqFtEndRange: 0,
  //         lotSizeEndRange: 0,
  //         lotSizeStartRange: 0,
  //         yearBuiltStartRange: 0,
  //         yearBuiltEndRange: 0,
  //       };
  //       await dispatch(fetchProperties(propertyData)).unwrap();
  //     } catch (error) {
  //       console.log("Error fetching the properties...", error);
  //     }
  //   };

  //   fetchingProperties();
  // }, []);

  const handleIncrementChange = (amount) => {
    setIncrement(amount);

    if (chatData?.newAskAmount < chatData?.currentHighestBid + amount) {
      setBidAmount(parseInt(chatData?.currentHighestBid) + amount)
      if (bidAmount > chatData?.currentHighestBid + amount) {
        setBidAmount(bidAmount);
      }
    }
    else {
      setBidAmount(chatData?.newAskAmount);
    }
    if (Array.isArray(chatData) && chatData.length < 1) {
      setBidAmount(auctionDetail?.currentHighestBid + amount)
    }
  };

  const handlePlus = () => {
    const currentHighestBid = chatData?.currentHighestBid || AuctioneerNeed?.data?.currentHighestBid || auctionDetail?.currentHighestBid
    setBidAmount((prev) => {
      if (currentHighestBid > Number(prev)) {
        return Number(currentHighestBid) + Number(increment)
      } else {
        return Number(prev) + Number(increment)
      }

    });
  };

  const handleMinus = () => {
    const threshold = (chatData?.currentHighestBid || AuctioneerNeed?.data?.currentHighestBid || auctionDetail?.currentHighestBid) + increment || chatData.newAskAmount;
    setBidAmount((prev) => {
      const newAmount = Number(prev) - Number(increment);
      // Only set new amount if it is greater than or equal to the threshold
      return newAmount >= threshold ? newAmount : prev;
    });
  };

  // Determine if the button should be enabled
  const threshold = (AuctioneerNeed?.data?.newAskAmount || AuctioneerNeed?.data?.askAmount || auctionDetail?.askAmount) + increment;
  const canMinus = Number(bidAmount) > threshold;

  useEffect(() => {
    if ((chatData?.newAskAmount == 0 || chatData?.askAmount == 0) && chatData?.currentHighestBid == 0) {
      setBidAmount(null);
    } else {
      const currentAskAmount = Number(chatData?.newAskAmount || chatData?.askAmount);
      const currentBid = Number(chatData?.currentHighestBid + increment);
      if (currentAskAmount !== currentBid && bidAmount > currentBid) {
        setBidAmount(bidAmount)
      } else {
        const inputValue = (chatData?.newAskAmount || chatData?.askAmount) > chatData?.currentHighestBid + increment ? (chatData?.newAskAmount || chatData?.askAmount) : chatData?.currentHighestBid + increment;
        setBidAmount(parseInt(inputValue));
      }

    }
  }, [chatData, showHighmsg]);

  const placeBid = async () => {
    if (!connection || connection.state !== 'Connected') {
      console.log('Connection not ready, attempting to reconnect...');
      await attemptReconnect();
      return;
    }

    try {
      const bidRequest = {
        Amount: parseInt(bidAmount),
        investorId: parseInt(investorId),
        auctionId: auctionDetail?.id,
        bidderId: `${investorId}`,
        purchaseProfileId: selectedProfile.InvestorId || investorId,
      };

      await connection.invoke('PlaceLiveBid', bidRequest);
      setMessages([...messages, `Bid Placed: ${bidAmount}`]);
    } catch (error) {
      console.error('Error placing bid:', error);
      if (error.message.includes('WebSocket closed')) {
        await attemptReconnect();
      }
    }
  };


  useEffect(() => {
    if (isFirstTime) {
      dispatch(firstTimeClosingMenuBar());
    }
  }, [isFirstTime])

  const getAuctionStatus = async () => {
    if (auctionId) {
      const id = selectedProfile?.InvestorId || investorId
      setisliveLoader(true)
      const params: ApiRequestParams = {
        endpoint: `investor/auction-current-status/${auctionId}/${id}`,
        baseUrl: getInvestorApiUrl()
      }
      await handleFetchApi(params).then((data) => {
        setIsLive(data?.data.data)
        setisliveLoader(false)

      })
    }
  }

  useEffect(() => {
    if (auctionId && broadcastMsg) {
      getAuctionStatus()
    }
  }, [auctionId, broadcastMsg, selectedProfile])
  const NextAuction = () => {
    // Resetting state
    setBidAmount([]);
    setChatData([]);
    setBroadcastMsg([]);
    setAuctioneerNeed([]);
    setResponseMessage('');

    // Find the index of the current auction
    const currentAuctionIndex = auctionList.findIndex(
      (auction) => auction.id === parseInt(auctionId)
    );

    if (currentAuctionIndex !== -1 && currentAuctionIndex < auctionList.length - 1) {
      // Get the next auction from the list
      const nextAuction = auctionList[currentAuctionIndex + 1];

      if (nextAuction) {
        // Navigate to the next auction
        navigate(`/liveauction/${nextAuction.id}`);


        const params: ApiRequestParams = {
          baseUrl: getInvestorAuctionerUrl(),
          endpoint: `auction/user/1/${nextAuction.id}`
        }

        handleFetchApi(params).then((response) => {
          const todayAuctions = response?.data?.data?.Today;
          if (todayAuctions) {
            setAuctionList(todayAuctions);
          } else {
            console.error("Expected data structure not found:", response.data);
          }
        })
          .catch((error) => {
            console.error("Error fetching auction data:", error);
          })
          .finally(() => {
            console.log("Next auction navigation complete.");
          });


        // // Fetch additional details for the next auction if needed
        // axios(`${baseUrl}/auction/user/1/${nextAuction.id}`)
        //   .then((response) => {
        //     const todayAuctions = response?.data?.data?.Today;
        //     if (todayAuctions) {
        //       setAuctionList(todayAuctions);
        //     } else {
        //       console.error("Expected data structure not found:", response.data);
        //     }
        //   })
        //   .catch((error) => {
        //     console.error("Error fetching auction data:", error);
        //   })
        //   .finally(() => {
        //     console.log("Next auction navigation complete.");
        //   });
      }
    } else {
      console.error("No more auctions available or invalid auction index.");
    }
  };

  const handleChange = (e) => {
    const cursorPosition = e.target.selectionStart;
    const oldValue = e.target.value;
    const oldLength = oldValue.length;

    // Remove only $ and commas, keep all digits including zeros
    let rawValue = e.target.value.replace(/[$,]/g, '');

    // If empty after removing $ and commas, set to empty string
    if (!rawValue) {
      setBidAmount('');
    } else {
      // Keep all digits including leading zeros
      setBidAmount(rawValue);
    }

    // Calculate new cursor position, accounting for commas
    requestAnimationFrame(() => {
      const newLength = e.target.value.length;
      const cursorOffset = newLength - oldLength;

      // Calculate the number of commas before the cursor in the old value
      const commasBeforeCursor = (oldValue.substring(0, cursorPosition).match(/,/g) || []).length;

      // Calculate the number of commas in the new value
      const totalCommas = (e.target.value.match(/,/g) || []).length;

      // Adjust cursor position based on comma changes
      let newPosition = cursorPosition + cursorOffset;
      if (cursorOffset < 0) { // If we're deleting
        // If cursor was after a comma, adjust position
        if (oldValue[cursorPosition - 1] === ',') {
          newPosition--;
        }
      } else if (cursorOffset > 0) { // If we're adding
        // If we added a comma, adjust position
        if (totalCommas > commasBeforeCursor) {
          newPosition++;
        }
      }

      // Ensure cursor is never before the $ symbol (position 1)
      newPosition = Math.max(1, newPosition);

      e.target.setSelectionRange(newPosition, newPosition);
    });
  };

  const formattedAmount = (() => {
    if (bidAmount === '') return '$';
    if (bidAmount === '0') return '$0';

    // If the value contains only zeros, preserve them
    if (/^0+$/.test(bidAmount)) {
      return '$' + bidAmount;
    }

    // For other numbers, format with commas
    return `$${new Intl.NumberFormat('en-US').format(bidAmount)}`;
  })(bidAmount);


  const { currentHighestBid, askAmount, newAskAmount } = AuctioneerNeed?.data || {};
  const buttonStyles = "w-16 xl:w-20 py-2  text-sm xl:text-base rounded-lg font-medium";


  const handleSearchNavigate = () => {
    navigate('/search')
  }

  const handleProfileSelect = (InvestorId, UserType, ProfileName) => {
    const profile = { InvestorId, UserType, ProfileName };
    dispatch(setSelectedProfileForAuction({ auctionId, profile }));
    setSelectedProfile(profile);
    setOpenProfileModal(false);
  };

  const handleCloseProfileModal = () => {
    setOpenProfileModal(false);
  };



  useEffect(() => {
    if (!selectedProfiles && userData) {
      // Set default profile using investor's own profile
      handleProfileSelect(investorId, userData.userType, userData?.profileName?.length > 1 ? userData?.profileName : userData?.BusinessDetailsResponse?.BusinessName || userData?.firstName + ' ' + userData?.lastName);
    } else {
      if (sessionStorage.getItem("isImpersonate") !== "true") {
        setSelectedProfile({ ...selectedProfiles });
      }
    }
  }, [userData, selectedProfiles]);

  const NumberFormatterdash = ({ amount = 0 }) => {
    // Handle the case where amount is "-" (string)
    if (amount === "-") {
      return "-";
    }

    // Handle the case where amount is 0
    if (amount === 0) {
      return "-";
    }

    // Format the number if it's not 0
    return new Intl.NumberFormat('en-US').format(amount);
  };


  const isPaused = isLive?.auctionStatus === 'Pause';
  const highestBid = chatData?.currentHighestBid || currentHighestBid || auctionDetail?.currentHighestBid || 0;
  const shouldShowDollar = !isPaused && highestBid !== 0;

  const exists = profileList?.some(profile =>
    profile?.investorId == isLive?.proxyInvestorId
  );
  const isExcludedStatus = excludedStatuses.includes(isLive?.auctionStatus) || (isPostponed && !isPastSaleDate);
  return (
    <>
      <div className='flex justify-start items-center'>
      </div>
      <div className='livedetailContainer'>
        <Helmet>
          <title>{`xBid | Live Auction`}</title>
          <meta name="description" content={`Live auction details${auctionDetail?.address ? ` for property at ${auctionDetail.address}` : ''}. Current highest bid: $${chatData?.currentHighestBid || auctionDetail?.currentHighestBid || 0}. Join the bidding now!`} />
          <meta property="og:title" content={`Live Auction${auctionDetail?.address ? ` - ${auctionDetail.address}` : ''}`} />
          <meta property="og:description" content={`Live auction details${auctionDetail?.address ? ` for property at ${auctionDetail.address}` : ''}. Current highest bid: $${chatData?.currentHighestBid || auctionDetail?.currentHighestBid || 0}`} />
          <meta name="robots" content="noindex,nofollow" />
        </Helmet>
        <div >
          <div className='w-full justify-center m-auto flex flex-col lg:flex-row'>
            {/* Sidebar */}
            {/* <div className='w-full lg:w-1/6 h-screen bg-slate-300'>Sidebar</div> */}
            <div className='w-full lg:w-full p-4 md:p-2 '>
              {/* Funds */}
              <FundsHeader viewAllAuctionLink={true} funds={funds} />
              {
                initialId.length == 0 ?

                  <>
                    <div className='mt-14 text-[22px] font-[600] text-darkGray sm:ml-[25px]'>
                      No Live Auctions at the moment
                    </div>

                    <div className="col-span-full  bg-[#FCF8E3] p-3 flex justify-between items-center mt-4 sm:ml-[25px]">

                      <div className='text-[#8A6D3B] text-[18px] font-[400]'>
                        Please check back later or explore our exclusice list of foreclosure properties to plan your next bid.
                      </div>

                      <div className='text-[#FF5C39] text-[20px] cursor-pointer' aria-label="Search" onClick={() => handleSearchNavigate()}>
                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                      </div>

                    </div>
                  </>

                  :
                  <>
                    <AuctionListHeader properties={initialId} HandleAuction={HandleAuction} auctionDetail={auctionDetail} scroll={scroll} scrollContainerRef={scrollContainerRef} auctionId={auctionId} />

                    <div className='flex flex-col sm:flex-row justify-between gap-5 mt-5'>
                      <div className='w-full sm:w-5/12 order-2 sm:order-1'>

                        <div className='flex sm:min-h-8 md:min-h-20 p-3 bg-white shadow justify-between' >
                          <div>
                            <div className='font-[500] text-[15.5px] sm:text-base xl:text-xl cursor-pointer'>{auctionDetail?.address}</div>

                            {auctionDetail?.id && <div className='mt-2 font-[500] text-sm xl:text-base'><span className='text-base xl:text-xl font-[500]'>
                              $
                              {auctionDetail?.estOpeningBidAmount === null || auctionDetail?.estOpeningBidAmount === 0.00 || auctionDetail?.estOpeningBidAmount === 0
                                ? (auctionDetail?.reservePrice > 0 ? formatToDollar(auctionDetail?.reservePrice) : 0)
                                : formatToDollar(
                                  auctionDetail?.estOpeningBidAmount
                                )}


                            </span> Est. Opening Bid</div>}
                          </div>
                          <div>
                            {
                              auctionDetail?.auctionStatus == "Live" && <LiveIcon />
                            }
                          </div>
                        </div>
                        <div className='p-2 mt-4 shadow bg-white h-full max-h-min'>
                          <div className='font-semibold text-base xl:text-[22px] mt-1 mb-3'>Auction Broadcast</div>
                          <Divider sx={{ borderBottomWidth: 1, borderColor: "gray" }} />
                          <ChatBroadcast broadcastMsg={broadcastMsg} investorId={investorId} />
                        </div>
                      </div>
                      <div className='w-full sm:w-7/12 order-1 sm:order-1'>

                        <div
                          className={'flex flex-col gap-2 sm:text-base xl:text-lg font-[500] gap-y-3 xl:gap-y-6 items-center bg-white shadow p-2'}
                        >
                          <div className='flex gap-2 items-center'>
                            <span className={`text-right font-[500]  ${chatData?.highestBidderId == investorId ? ' text-[#28A745]' : ""}`} >Current Highest Bid:</span>
                            {
                              chatData?.auctionRedoCount == 0 || chatData?.auctionRedoCount == undefined || chatData?.auctionRedoCount >= 0 && chatData?.auctionStatus == "Closed" ?
                                <span className={`text-left sm:text-xl  xl:text-3xl font-bold ${chatData?.highestBidderId == investorId ? 'text-[#28A745]' : ""}`}>
                                  {shouldShowDollar && "$"}
                                  <NumberFormatterdash amount={isPaused || highestBid === 0 ? "-" : highestBid} />
                                </span>
                                :
                                <span className={`text-left sm:text-xl  xl:text-3xl font-bold`}>
                                  -
                                </span>
                            }


                          </div>

                          <div className='flex gap-2 items-center'>
                            <span className="text-right font-[500]">Auctioneer's Ask:</span>
                            <span className="text-left sm:text-xl  xl:text-3xl font-bold">
                              {
                                chatData?.auctionRedoCount == 0 || chatData?.auctionRedoCount == undefined || chatData?.auctionRedoCount >= 0 && chatData?.auctionStatus == "Closed" ?
                                  <>
                                    {
                                      parseInt(
                                        Number(chatData?.newAskAmount) ||
                                        Number(auctionDetail?.askAmount) ||
                                        0, // Default to 0 if all values are undefined or NaN
                                        10 // Specify the radix (base) for the parseInt
                                      ) == 0 ? "" : "$"
                                    }
                                    <NumberFormatterdash
                                      amount={parseInt(
                                        Number(auctionDetail?.newAskAmount) ||
                                        isLive?.auctionStatus === 'Pause',
                                        0, // Default to 0 if all values are undefined or NaN
                                        10 // Specify the radix (base) for the parseInt
                                      ) == 0 ? "-" :
                                        parseInt(
                                          Number(chatData?.newAskAmount || chatData?.askAmount) ||
                                          Number(auctionDetail?.askAmount) ||

                                          0, // Default to 0 if all values are undefined or NaN
                                          10 // Specify the radix (base) for the parseInt
                                        )
                                      }

                                    />
                                  </>
                                  :
                                  "-"
                              }

                            </span>


                          </div>
                          {(isLive?.preauctionBidAmount > 0 && exists || isLive?.proxyInvestorId === investorId) && (
                            <div className='flex gap-2 items-center ml-[32px]'>
                              <span className="text-right font-[500]">Proxy Bid Placed:</span>
                              <span className="text-left sm:text-xl xl:text-3xl font-bold flex items-center gap-2">
                                $<NumberFormatter amount={isLive?.preauctionBidAmount} />
                                <Tooltip
                                  title={`System will place bids on your behalf up to $${isLive?.preauctionBidAmount.toLocaleString()}. You can place bids manually once the ask exceeds this amount.`}
                                  arrow
                                >                      <svg
                                  stroke="#FF5C39" fill="#FF5C39" strokeWidth="0" viewBox="0 0 16 16"
                                  height="20px" width="20px" xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path fillRule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z" clipRule="evenodd"></path>
                                    <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"></path>
                                    <circle cx="8" cy="4.5" r="1"></circle>
                                  </svg>
                                </Tooltip>
                              </span>
                            </div>
                          )}

                          {/* <div className={`${chatData?.broadCastMessage?.includes('Remote') ? ' text-[#28A745]' : ""}  p-2 font-[500] text-lg flex justify-center items-center gap-2`} >Current Highest Bid: <strong className='text-2xl'>$ <NumberFormatter amount={AuctioneerNeed?.data?.currentHighestBid || auctionDetail?.currentHighestBid} /></strong></div>
                <div className='p-2 font-[500] text-lg flex justify-center items-center gap-2'>Auctioneer's Ask: <strong className='text-2xl'>$ <NumberFormatter amount={AuctioneerNeed?.data?.newAskAmount || AuctioneerNeed?.data?.askAmount || auctionDetail?.askAmount} /></strong></div>
                {proxyamount?.preauctionBidAmount &&
                  <div className='p-2 font-[500] text-lg flex justify-center items-center gap-2 '>Proxy Bid Placed: <strong className='text-2xl'>$<NumberFormatter amount={proxyamount?.preauctionBidAmount} /></strong>
                    <svg stroke="#FF5C39" fill="#FF5C39" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z" clipRule="evenodd"></path><path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"></path><circle cx="8" cy="4.5" r="1"></circle></svg>
                  </div>
                } */}
                        </div>
                        <div className="mt-5 shadow sm:min-h-[70vh] bg-white h-[80%]">
                          {
                            <>
                              {isExcludedStatus ? (
                                <AuctionStatus isLive={isLive} NextAuction={NextAuction} RemoveAuctionfromList={RemoveAuctionfromList} />
                              ) : (
                                <>
                                  <div className="min-h-4 sm:min-h-20 sm:pt-16 xs:min-h-4 xs:pt-4">

                                    {(notificationId == investorId) && chatData?.biddingType !== "Ask" && message && (status == 200 || status == 201) && (
                                      <div
                                        className={`border max-w-64 xl:max-w-[23rem] min-h-10 xl:min-h-12 xl:text-lg font-medium justify-center flex m-auto p-[10px] text-center rounded ${status === 200
                                          ? "text-[#28A745] border-[#28A745]"
                                          : "text-[#EF233C] border-[#EF233C]"
                                          }`}
                                      >
                                        {message}

                                      </div>
                                    )}
                                  </div>

                                  <div className="flex flex-col items-center justify-center sm:gap-y-4 gap-y-2 px-6 py-4">
                                    {/* Increment / Decrement Controls */}
                                    <div className="flex items-center space-x-4">
                                      <button
                                        className={`w-12 h-12 xl:w-14 xl:h-14 text-3xl font-medium rounded-full ${canMinus ? "bg-[#087CA7] text-white" : "bg-[#9FA4AB] text-white"
                                          }`}
                                        aria-label="minus button"
                                        onClick={canMinus ? handleMinus : undefined}
                                        disabled={!canMinus}
                                      >
                                        -
                                      </button>
                                      <input
                                        value={formattedAmount == "$NaN" ? 0 : formattedAmount}
                                        onChange={handleChange}
                                        className="w-60 xl:w-80 h-12 xl:h-16 text-center border-2 border-gray-300 rounded-lg outline-none bg-white text-xl xl:text-3xl font-bold"
                                      />
                                      <button
                                        className="w-12 h-12 xl:w-14 xl:h-14 text-3xl font-medium bg-[#087CA7] text-white rounded-full"
                                        onClick={handlePlus}
                                        aria-label="handle plus button"
                                      >
                                        +
                                      </button>
                                    </div>

                                    {/* Place Bid Button */}
                                    <Button variant="contained"
                                      sx={{
                                        width: '50%',
                                        maxWidth: '250px',
                                        height: '48px',
                                        backgroundColor: '#FF5C39',
                                        color: 'white', // Text color
                                        borderRadius: '5px',
                                        fontSize: '1.2rem',
                                        textTransform: "capitalize",
                                        fontWeight: 500,
                                        '&:hover': {
                                          backgroundColor: '#ff4515',
                                        },
                                        margin: '16px 0',
                                      }}
                                      onClick={placeBid}>
                                      Place Bid</Button>


                                    {
                                      (status !== 200 && status !== 201 && errorId == investorId) && (
                                        <div className='text-[#FF0000] mt-[-5px]'>
                                          {message}
                                        </div>
                                      )
                                    }


                                    <div>

                                    </div>

                                    {/* Increment Buttons */}
                                    <div className="flex gap-3 mt-2">
                                      {[1000, 2500, 5000, 10000]?.map((value) => (
                                        <button
                                          key={value}
                                          aria-label="value increment"
                                          className={`${increment === value
                                            ? "bg-[#087CA7] text-white"
                                            : "bg-[#087CA729] text-[#087CA7]"
                                            } ${buttonStyles}`}
                                          onClick={() => handleIncrementChange(value)}
                                        >
                                          ${value.toLocaleString()}
                                        </button>
                                      ))}
                                    </div>

                                    <div className="text-center font-medium">
                                      Your current bid increment is set to ${increment.toLocaleString()}
                                    </div>
                                    {/* Purchase Profile */}
                                    <div className="mt-4 font-semibold">Purchase Profile</div>
                                    <div className="flex items-center">
                                      <div onClick={() => setOpenProfileModal(true)} className="bg-white border border-gray-300 rounded-full px-4 gap-2 py-2 flex items-center">
                                        <div>
                                          {(() => {
                                            // Find the profile that matches selectedProfiles?.InvestorId
                                            const matchedProfile = profileList?.find(
                                              (p) => p.investorId == selectedProfiles?.InvestorId
                                            );
                                            // If not found, find the default profile
                                            const defaultProfile = profileList?.find(
                                              (p) => p.isDefault
                                            );
                                            // Decide which profile to show as selected
                                            const profileToShow = matchedProfile || defaultProfile || selectedProfiles;
                                            return (
                                              <>
                                                <span className="font-semibold">
                                                  {profileToShow?.profileName?.length > 1
                                                    ? profileToShow?.profileName || profileToShow?.BusinessDetailsResponse?.BusinessName
                                                    : profileToShow?.firstName}
                                                </span>{" "}
                                                <span className="text-sm ml-1">({profileToShow?.userType || profileToShow?.UserType})</span>
                                              </>
                                            );
                                          })()}
                                        </div>
                                        <svg
                                          stroke="currentColor"
                                          fill="none"
                                          strokeWidth="2"
                                          viewBox="0 0 24 24"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          height="1em"
                                          width="1em"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                        </svg>
                                      </div>
                                    </div>
                                    <Modal
                                      open={openProfileModal}
                                      onClose={handleCloseProfileModal}
                                      aria-labelledby="profile-modal"
                                      aria-describedby="profile-selection-modal"
                                    >
                                      <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-md p-6 sm:w-[500px] w-[380px]">
                                        <div className="flex justify-between items-center mb-6">
                                          <h2 className="text-[18px] text-[#2D3748] font-[500]">Select a purchase profile</h2>
                                          <button
                                            aria-label="close profile model"
                                            onClick={handleCloseProfileModal}
                                            className="text-[#2D3748] hover:text-gray-700"
                                          >
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                              <path d="M18 6L6 18M6 6L18 18" stroke="#2D3748" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                          </button>
                                        </div>

                                        <div className="space-y-0 border rounded-lg">
                                          {profileList && profileList?.map((profile, index) => (
                                            <div
                                              key={index}
                                              className={`p-4 cursor-pointer border-b border-gray-200 flex items-center gap-4 ${profile.AccountStatus === "Pending" ? "opacity-50" : ""
                                                }`}
                                              onClick={() => handleProfileSelect(profile?.investorId, profile?.userType, profile?.profileName.length > 1 ? profile?.profileName : profile?.firstName)}
                                            >
                                              <div className="w-6 h-6 rounded-full border border-gray-400 flex items-center justify-center">
                                                {(() => {
                                                  // Find the profile that matches selectedProfiles?.InvestorId
                                                  const matchedProfile = profileList?.find(
                                                    (p) => p.investorId == selectedProfiles?.InvestorId
                                                  );
                                                  // If not found, find the default profile
                                                  const defaultProfile = profileList?.find(
                                                    (p) => p.isDefault
                                                  );
                                                  // Decide which profile to show as selected
                                                  const profileToShow = matchedProfile || defaultProfile || selectedProfiles;
                                                  return profileToShow?.InvestorId === profile.investorId || profileToShow?.investorId === profile.investorId ? (
                                                    <div className="w-4 h-4 rounded-full bg-[#FF5C39] border-2 border-white"></div>
                                                  ) : null;
                                                })()}
                                              </div>
                                              <div className="flex items-center">
                                                <div className="text-[#2D3748] text-lg font-medium">{profile.profileName?.length > 1 ? profile.profileName : profile.firstName}</div>
                                                <div className="text-[#718096]">({profile.userType})</div>
                                              </div>
                                              {profile.AccountStatus === "Pending" && (
                                                <span className="text-sm text-amber-600">Pending Verification</span>
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                      </Box>
                                    </Modal>
                                  </div>
                                </>
                              )}
                            </>

                          }

                        </div>
                      </div>
                    </div>
                  </>
              }
              {/* Today's Auctions */}

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
